import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { resetSelectedGoal, resetSelectedSubGoal } from "../../redux/reducers/goalsAndStrategy";
import { resetSelectedProject, resetsetProjectDetails } from "../../redux/reducers/actionPlan";
import { setDrawer } from "../../redux/reducers/common";
import { goalProjectDetailsRegex, selectedGoalRegex, selectedSubGoalRegex, subGoalProjectDetailsRegex } from "../../common/StaticExports";

const GoalsBreadCrumb = () => {
    const navigate = useNavigate();
    const [t] = useTranslation();
    const location = useLocation();
    const selectedGoal = useSelector((state:any) => state.goalsAndStrategy.selectedGoal);
    const selectedSubGoal = useSelector((state:any) => state.goalsAndStrategy.selectedSubGoal);
    const selectedProject = useSelector((state:any) => state.actionPlan.details);
    const dispatch = useDispatch();

    return (
        <Box sx={{ display: "flex" }}>
        <Typography className="fs14 uppercase cursorPointer fw700"
        onClick={() => {
            navigate('/goals');
            const moduleName:any = 'Goals & Strategy';
            dispatch(setDrawer(moduleName));
            dispatch(resetSelectedGoal());
            dispatch(resetSelectedProject());
            dispatch(resetsetProjectDetails());
        }}>
            {`${t('ACADEMY')} ${t('GOALS')}`}
        </Typography>
        {
            selectedGoal && selectedGoal != undefined &&
            selectedGoal != null && 
            (selectedGoalRegex.test(location.pathname) ||
            selectedSubGoalRegex.test(location.pathname) ||
            goalProjectDetailsRegex.test(location.pathname) ||
            subGoalProjectDetailsRegex.test(location.pathname)
            ) &&
            <>
            <Typography className="fs14 mr10 ml10 fw700">
                {`>`}
            </Typography>
            <Typography className="fs14 fw700"
            onClick={() => {
                navigate(`/goals/${selectedGoal?.id}`);
                dispatch(resetSelectedSubGoal());
                dispatch(resetSelectedProject());
                dispatch(resetsetProjectDetails());
            }}>
                {`${selectedGoal.name}`}
            </Typography>
            </>
        }
        {
            selectedSubGoal && selectedSubGoal != undefined &&
            selectedSubGoal != null && 
            (selectedSubGoalRegex.test(location.pathname) ||
             subGoalProjectDetailsRegex.test(location.pathname)
            ) &&
            <>
            <Typography className="fs14 mr10 ml10 fw700">
                {`>`}
            </Typography>
            <Typography className="fs14 fw700"
            onClick={() => {
                navigate(`/goals/${selectedGoal?.id}/subgoals/${selectedSubGoal?.id}`);
                dispatch(resetSelectedProject());
                dispatch(resetSelectedProject());
                dispatch(resetsetProjectDetails());
            }}>
                {`${selectedSubGoal.name}`}
            </Typography>
            </>
        }
        {
            selectedProject && selectedProject != undefined &&
            selectedProject != null && 
            (goalProjectDetailsRegex.test(location.pathname) ||
            subGoalProjectDetailsRegex.test(location.pathname)
            ) &&
            <>
            <Typography className="fs14 mr10 ml10 fw700">
                {`>`}
            </Typography>
            <Typography className="fs14 fw700">
                {`${selectedProject.name}`}
            </Typography>
            </>
        }
        </Box>
    )
}

export default GoalsBreadCrumb;